import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type {
  ITransfersPayload,
  ITransfersSummaryCardsPayload,
} from '@app/dashboard/types/innerLayout/balance_and_transfers/transfers/table-listing';

export const getTransfers = ({
  currentPage,
  pageSize,
  params = {},
}: ITransfersPayload) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    ...params,
  };

  return axiosPrivate.get('/dashboard/v2/transfers/listing', {
    params: queryParams,
  });
};

export const getTransfersCardsTabs = ({
  appliedRanges,
  accountId,
  currency,
  signal,
}: ITransfersSummaryCardsPayload) => {
  return axiosPrivate.get('/dashboard/v2/transfers/summary-cards', {
    params: {
      start_date: appliedRanges.start_date,
      end_date: appliedRanges.end_date,
      bank_account_number: accountId,
      currency,
    },
    signal,
  });
};
